export const validationRules = {
  emailAddress: ['required', 'validEmail'],
  password: ['required', 'validPassword'],
  terms: ['required'],
  name: ['required'],
  firstName: ['required'],
  lastName: ['required'],
  birthDate: ['required', 'len-10'],
  address1: ['required', 'lt-37'],
  countryCode: ['required'],
  zip: ['required', 'len-5'],
  postalCode: ['required', 'len-5'],
  city: ['required', 'lt-23'],
  stateCode: ['required', 'validState'],
  cellPhone: ['gt-9', 'lt-13'],
  workPhone: ['required', 'gt-9', 'lt-13'],
};

export const institutionValidationRules = {
  name: ['required'],
  address1: ['required'],
};

export const irregularitiesValidationRules = {
  roomName: ['required'],
  firstName: ['required'],
  lastName: ['required'],
  matchId: ['required'],
};

export const emailValidationRules = {
  subject: ['required'],
  description: ['required'],
  testCenterId: ['required'],
  testCenterEventId: ['required'],
};

export const renewPersonRules = {
  firstName: ['required'],
  lastName: ['required'],
  phone: ['gt-9', 'lt-13'],
  emailAddress: ['validEmail'],
};

export const secureStaffRules = {
  storageContainer: ['required'],
  storageLocation: ['required'],
};

export const pauseValidationRules = {
  pauseDateTime: ['required'],
  unpauseDateTime: ['required'],
  pauseDescription: ['required'],
};

export const manualTimerValidationRules = {
  startDateTime: ['required'],
  warning30DateTime: ['required'],
  warning5DateTime: ['required'],
  stopDateTime: ['required'],
};

export const roomMaterialValidationRules = {
  usedCount: ['requiredOrZero'],
  unusedCount: ['requiredOrZero'],
};

export const roomCloseValidationRules = {
  examineeCount: ['requiredOrZero'],
  answerDocScored: ['requiredOrZero'],
  answerDocVoided: ['requiredOrZero'],
  answerDocReplaced: ['requiredOrZero'],
};

export const materialRangeRules = {
  rangeBegin: ['required', 'len-9', 'startsWithOne'],
  rangeEnd: ['required', 'len-9', 'startsWithOne'],
  count: ['required'],
};

export const materialRangeClosedRoomRules = {
  rangeBegin: ['requiredOrZero'],
  rangeEnd: ['requiredOrZero'],
  count: ['required'],
};

export const seatingDetailsRules = {
  seatingRowCount: ['required'],
  seatingColumnCount: ['required'],
  writingSurfaceWidth: ['required'],
  writingSurfaceDepth: ['required'],
  distanceBetweenShoulders: ['required'],
  distanceBetweenHeads: ['required'],
};

export const shippingValidationRules = {
  shipToName: ['required'],
  address1: ['required', 'lt-37'],
  address2: ['required', 'lt-37'],
  address3: ['lt-37'],
  postalCode: ['required', 'len-5'],
  city: ['required'],
  stateCode: ['required', 'validState'],
};

export const documentsRules = {
  scored: ['requiredOrZero'],
  voided: ['requiredOrZero'],
  replaced: ['requiredOrZero'],
};

export const closeRoomIrregularityRules = {
  irregularities: ['required'],
};

export const nonPersonnelValidationRules = {
  emailAddress: ['required', 'validEmail'],
  firstName: ['required', 'lt-26', 'name'],
  lastName: ['required', 'lt-26', 'name'],
  phone: ['required', 'gt-9', 'lt-13'],
};

export const errorStrings = {
  emailAddress: {
    required: 'errors.emailRequired',
    validEmail: 'errors.emailInvalid',
  },
  name: {
    required: 'errors.institutionNameRequired',
  },
  password: {
    required: 'errors.passwordRequired',
    validPassword: 'errors.passwordInvalid',
  },
  terms: {
    required: 'errors.termsRequired',
  },
  firstName: {
    required: 'errors.firstNameRequired',
    name: 'errors.specialCharactersNotAllowed',
  },
  lastName: {
    required: 'errors.lastNameRequired',
    name: 'errors.specialCharactersNotAllowed',
  },
  birthDate: {
    required: 'errors.dateOfBirthRequired',
    len: 'errors.dateOfBirthLength',
  },
  address1: {
    required: 'errors.addressRequired',
    lt: 'errors.addressTooLong',
  },
  address2: {
    required: 'errors.addressRequired',
  },
  countryCode: {
    required: 'errors.countryRequired',
  },
  postalCode: {
    required: 'errors.zipRequired',
    len: 'errors.zipLength',
    numeric: 'errors.onlyNumbersAllowed',
  },
  zip: {
    required: 'errors.zipRequired',
    len: 'errors.zipLength',
  },
  city: {
    required: 'errors.cityRequired',
    specialChars: 'errors.specialCharactersNotAllowed',
    lt: 'errors.cityLimitation',
  },
  stateCode: {
    required: 'errors.stateRequired',
    letters: 'errors.onlyLettersAllowed',
    validState: 'errors.invalidState',
    specialChars: 'errors.specialCharactersNotAllowed',
  },
  cellPhone: {
    required: 'errors.phoneRequired',
    gt: 'errors.phoneLonger',
    lt: 'errors.phoneShorter',
    numeric: 'errors.onlyNumbersAllowed',
  },
  workPhone: {
    required: 'errors.phoneRequired',
    gt: 'errors.phoneLonger',
    lt: 'errors.phoneShorter',
    numeric: 'errors.onlyNumbersAllowed',
  },
  workPhoneExt: {
    numeric: 'errors.onlyNumbersAllowed',
  },
  pin: {
    required: 'errors.pinCodeRequired',
    len: 'errors.pinCodeLength',
    numeric: 'errors.onlyNumbersAllowed',
  },
};

export const nonPersonnelErrorStrings = {
  firstName: {
    required: 'errors.firstNameRequired',
    name: 'errors.specialCharactersNotAllowed',
    lt: 'errors.firstNameLength',
  },
  lastName: {
    required: 'errors.lastNameRequired',
    name: 'errors.specialCharactersNotAllowed',
    lt: 'errors.lastNameLength',
  },
  emailAddress: {
    required: 'errors.emailRequired',
    validEmail: 'errors.emailInvalid',
  },
  phone: {
    required: 'errors.phoneRequired',
    gt: 'errors.phoneLonger',
    lt: 'errors.phoneShorter',
    numeric: 'errors.onlyNumbersAllowed',
  },
};

export const institutionErrorStrings = {
  name: {
    required: 'errors.institutionNameRequired',
  },
};

export const irregularitiesErrorStrings = {
  roomName: {
    required: 'errors.roomNameRequired',
  },
  firstName: {
    required: 'errors.firstNameRequired',
  },
  lastName: {
    required: 'errors.lastNameRequired',
  },
  matchId: {
    required: 'errors.matchIdRequired',
  },
};

export const emailErrorStrings = {
  subject: {
    required: 'errors.subjectRequired',
  },
  description: {
    required: 'errors.descriptionRequired',
  },
  testCenterId: {
    required: 'errors.testCenterRequired',
  },
  testCenterEventId: {
    required: 'errors.testCenterEventRequired',
  },
};

export const renewPersonErrorStrings = {
  firstName: {
    required: 'errors.firstNameRequired',
    name: 'errors.specialCharactersNotAllowed',
  },
  lastName: {
    required: 'errors.lastNameRequired',
    name: 'errors.specialCharactersNotAllowed',
  },
  phone: {
    gt: 'errors.phoneLonger',
    lt: 'errors.phoneShorter',
  },
  emailAddress: {
    validEmail: 'errors.emailInvalid',
  },
};

export const secureStaffErrorStrings = {
  storageContainer: {
    required: 'errors.selectOption',
  },
  storageLocation: {
    required: 'errors.selectOption',
  },
  storageStudentAccess: {
    required: 'errors.firstNameRequired',
  },
};


export const pauseErrorStrings = {
  pauseDateTime: {
    required: 'errors.pauseDateTime',
  },
  unpauseDateTime: {
    required: 'errors.unpauseDateTime',
  },
  pauseDescription: {
    required: 'errors.pauseDescription',
  },
};

export const manualTimerErrorStrings = {
  startDateTime: {
    required: 'errors.startDateTime',
  },
  warning30DateTime: {
    required: 'errors.warning30DateTime',
  },
  warning5DateTime: {
    required: 'errors.warning5DateTime',
  },
  stopDateTime: {
    required: 'errors.stopDateTime',
  },
};

export const roomMaterialErrorStrings = {
  usedCount: {
    requiredOrZero: 'errors.fieldMandatory',
  },
  unusedCount: {
    requiredOrZero: 'errors.fieldMandatory',
  },
};

export const roomCloseErrorStrings = {
  examineeCount: {
    requiredOrZero: 'errors.fieldMandatory',
  },
  answerDocScored: {
    requiredOrZero: 'errors.fieldMandatory',
  },
  answerDocVoided: {
    requiredOrZero: 'errors.fieldMandatory',
  },
  answerDocReplaced: {
    requiredOrZero: 'errors.fieldMandatory',
  },
};


export const materialRangeErrorStrings = {
  rangeBegin: {
    required: 'errors.fieldMandatory',
    len: 'testCenter.testMaterialsRanges.error.materialLength',
    startsWithOne: 'testCenter.testMaterialsRanges.error.startsWithOne',
  },
  rangeEnd: {
    required: 'errors.fieldMandatory',
    len: 'testCenter.testMaterialsRanges.error.materialLength',
    startsWithOne: 'testCenter.testMaterialsRanges.error.startsWithOne',

  },
  count: {
    required: 'errors.fieldMandatory',
  },
};

export const materialRangeClosedRoomErrorStrings = {
  rangeBegin: {
    required: 'errors.fieldMandatory',
  },
  rangeEnd: {
    required: 'errors.fieldMandatory',
  },
  count: {
    required: 'errors.fieldMandatory',
  },
};

export const seatingDetailsErrorStrings = {
  seatingRowCount: {
    required: 'errors.fieldMandatory',
  },
  seatingColumnCount: {
    required: 'errors.fieldMandatory',
  },
  writingSurfaceWidth: {
    required: 'errors.fieldMandatory',
  },
  writingSurfaceDepth: {
    required: 'errors.fieldMandatory',
  },
  distanceBetweenShoulders: {
    required: 'errors.fieldMandatory',
  },
  distanceBetweenHeads: {
    required: 'errors.fieldMandatory',
  },
};

export const shippingDetailsErrorStrings = {
  shipToName: {
    required: 'errors.fieldRequired',
  },
  address1: {
    required: 'requestUpdate.shippingSection.address1Error',
    lt: 'errors.addressTooLong',
  },
  address2: {
    required: 'errors.fieldRequired',
    lt: 'errors.addressTooLong',
  },
  address3: {
    lt: 'errors.addressTooLong',
  },
  postalCode: {
    required: 'errors.fieldRequired',
    len: 'errors.zipLength',
  },
  city: {
    required: 'errors.fieldRequired',
  },
  stateCode: {
    required: 'errors.fieldRequired',
    validState: 'errors.invalidState',
  },
};

export const documentsErrorStrings = {
  voided: {
    requiredOrZero: 'errors.fieldMandatory',
  },
  scored: {
    requiredOrZero: 'errors.fieldMandatory',
  },
  replaced: {
    requiredOrZero: 'errors.fieldMandatory',
  },
  irregularities: {
    required: 'errors.fieldMandatory',
  },
};
